import { render } from "./PainelRelatorioPCPIndex.vue?vue&type=template&id=257164b6&scoped=true&ts=true"
import script from "./PainelRelatorioPCPIndex.vue?vue&type=script&lang=ts"
export * from "./PainelRelatorioPCPIndex.vue?vue&type=script&lang=ts"

import "./PainelRelatorioPCPIndex.vue?vue&type=style&index=0&id=257164b6&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257164b6"]])

export default __exports__